import Api from 'App/api'

export const getAccountSettings = Api.get({
  controller: 'account_settings',
  action: 'getSettings',
})

export const saveAccountSettings = Api.post({
  controller: 'account_settings',
  action: 'saveSettings',
})

export const getNotificationSettings = Api.get({
  controller: 'notification_settings',
  action: 'getSettings',
})

export const saveNotificationSettings = Api.post({
  controller: 'notification_settings',
  action: 'saveSettings',
})

// User profile
export const getProfile = Api.get({
  controller: 'customer_profile',
  action: 'getProfile',
})
export const verifyPassword = Api.post({
  controller: 'user',
  action: 'verifyPassword',
})
export const getProfileWithSettings = Api.get({
  controller: 'customer_profile',
  action: 'getProfileWithSettings',
})

export const saveProfile = Api.post({
  controller: 'customer_profile',
  action: 'saveProfile',
})

export const uploadProfileImage = Api.post({
  controller: 'customer_profile',
  action: 'uploadProfileImage',
})

// Roommate preference
export const getRoommateInterestsWithSettings = Api.get({
  controller: 'roommate_interests',
  action: 'getWithSettings',
})

export const saveRoommateInterests = Api.post({
  controller: 'roommate_interests',
  action: 'save',
})

export const updateTenantContactPassword = Api.post({
  controller: 'tenant_users',
  action: 'updatePasswordPersonalInfo',
})

export const updateGroupContactPassword = Api.post({
  controller: 'group_users',
  action: 'updatePassword',
})

export const updateEmail = Api.post({
  controller: 'customer_profile',
  action: 'updateEmail',
})

export const saveProfileForBulkPayment = Api.postWithToken({
  controller: 'customer_profile',
  action: 'saveProfile',
  useCustomToken: true,
})
